import { render, staticRenderFns } from "./ContratoRegistra.vue?vue&type=template&id=0b7389ad&"
import script from "./ContratoRegistra.vue?vue&type=script&lang=js&"
export * from "./ContratoRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports